import {
  RecipeFacetsDocument,
  type RecipeFacetsInput,
  type RecipeFacetsQuery,
} from '@mdvip/shared/graphql/generated/graphql';
import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export type { RecipeFacetsInput };
export type RecipeFacetGroups = RecipeFacetsQuery['recipeFacets'];

/**
 * No shared prefix key to invalidate by (unlike `recipesKey`) — every distinct filter/search
 * combination is its own cache entry, and there's no "invalidate every facet count" use case.
 */
export function useRecipeFacets(input: RecipeFacetsInput) {
  return useQuery({
    queryKey: ['recipes', 'facets', input] as const,
    queryFn: async () => {
      const data = await gqlRequest(RecipeFacetsDocument, { input });
      return data.recipeFacets;
    },
    placeholderData: keepPreviousData,
  });
}
